import React from 'react';
import SectionHeading from './SectionHeading';

const EMAILS = [
  { label: 'Personal', address: 'ishi961992@gmail.com' },
  { label: 'Aerveil', address: 'ishitas@aerveil.ai' },
];

const SOCIALS = [
  {
    label: 'LinkedIn',
    handle: 'ishita-srivastava',
    href: 'https://www.linkedin.com/in/ishita-srivastava-8aa66899/',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    label: 'Instagram',
    handle: 'aerveil.ai',
    href: 'https://www.instagram.com/aerveil.ai/',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311 1.266-.058 1.646-.07 4.85-.07zM12 0C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12s.014 3.668.072 4.948c.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z',
  },
];

const Contact = () => (
  <section id="contact" className="section bg-cream">
    <div className="shell">
      <SectionHeading
        number="06"
        label="Contact"
        title="Get in touch."
        intro="Email is the surest way to reach me. Both addresses come to me."
      />

      <div className="mt-16 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="overflow-hidden border border-ink/10">
            <img
              src="/img/portrait-golden-hour.jpg"
              alt="Ishita Srivastava"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="eyebrow text-ink-soft">Email</p>
          <ul className="mt-5 space-y-5">
            {EMAILS.map((e) => (
              <li key={e.address}>
                <p className="font-mono text-[0.68rem] uppercase tracking-eyebrow text-ink-soft">
                  {e.label}
                </p>
                <a
                  href={`mailto:${e.address}`}
                  className="link-underline mt-1.5 inline-block font-mono text-base text-ink hover:text-amber-deep md:text-lg"
                >
                  {e.address}
                </a>
              </li>
            ))}
          </ul>

          <p className="eyebrow mt-14 text-ink-soft">Elsewhere</p>
          <ul className="mt-5 space-y-4">
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-3.5 text-ink-muted transition-colors duration-300 hover:text-ink"
                >
                  <svg
                    className="h-4 w-4 flex-none text-ink-soft transition-colors duration-300 group-hover:text-amber-deep"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d={s.path} />
                  </svg>
                  <span className="font-mono text-[0.78rem] uppercase tracking-eyebrow">
                    {s.label}
                  </span>
                  <span className="font-mono text-[0.78rem] text-ink-soft">{s.handle}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
